import React from "react";
import { FormControl, InputLabel, Link, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * The body of a card that picks one row of a list (objective, laser,
 * substrate, camera calibration): a Select over `rows` ({ id, name, ... })
 * and, optionally, the sentence that points to the page where new rows are
 * created (`manage`: { text, linkLabel, route }). `onChange` receives the
 * chosen row.
 */
export default function ChoiceCard({ inputId, label, rows, valueId, onChange, manage = null, emptyHint = "" }) {
  const navigate = useNavigate();
  // A value the list does not hold would make the Select warn; the field
  // shows empty until the list has it.
  const value = rows.some((row) => row.id === valueId) ? valueId : "";

  return (
    <Stack spacing={2} alignItems="flex-start" sx={{ width: "100%" }}>
      <FormControl fullWidth sx={{ maxWidth: 480 }}>
        <InputLabel id={`${inputId}-label`}>{label}</InputLabel>
        <Select
          labelId={`${inputId}-label`}
          id={inputId}
          value={value}
          label={label}
          onChange={(event) => onChange(rows.find((row) => row.id === event.target.value))}
        >
          {rows.map((row) => (
            <MenuItem key={row.id} value={row.id}>
              {row.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {rows.length === 0 && emptyHint ? (
        <Typography variant="body2" color="text.secondary">
          {emptyHint}
        </Typography>
      ) : null}
      {manage ? (
        <Typography variant="body2" color="text.secondary">
          {manage.text}{" "}
          <Link
            component="button"
            type="button"
            onClick={() => navigate(manage.route)}
            sx={{ fontWeight: 600, verticalAlign: "baseline" }}
          >
            {manage.linkLabel}
          </Link>{" "}
          page.
        </Typography>
      ) : null}
    </Stack>
  );
}
